if (!customElements.get('pp-category-menu')) {
  class PpCategoryMenu extends HTMLElement {
    constructor() {
      super();
      this.updateArrows = this.updateArrows.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.frame = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track) return;

      if (this.prev) this.prev.addEventListener('click', () => this.scrollByPage(-1));
      if (this.next) this.next.addEventListener('click', () => this.scrollByPage(1));

      this.onScroll = () => {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.updateArrows();
        });
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateArrows);
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.updateArrows);
      }

      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.updateArrows();
    }

    disconnectedCallback() {
      if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.updateArrows);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    scrollByPage(direction) {
      const distance = Math.max(this.track.clientWidth * 0.8, 120);
      this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft >= maxScroll - 2;
      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd || maxScroll <= 0;
    }

    onBlockSelect(event) {
      if (!this.track || !this.track.contains(event.target)) return;
      const item = event.target;
      const left = item.offsetLeft - (this.track.clientWidth - item.clientWidth) / 2;
      this.track.scrollTo({ left: left, behavior: 'smooth' });
    }
  }

  customElements.define('pp-category-menu', PpCategoryMenu);
}
